export default "__VITE_ASSET__C5$bs7QE__"